module.exports = __webpack_public_path__ + "img/compass-logo.022fb16e.svg";